// Simple stock model (Jun 2026): quantities are tracked PER SIZE only.
// Variant availability (hilos/tradiciones/colores/algodón) comes from the
// product's out_of_stock_* / hidden_* fields, managed in the Admin panel.

const sizeKeys = (sq) => Object.keys(sq).filter((k) => !k.includes('|'));

// Returns { oosSizes } when the product tracks stock, or null (fall back to
// the manual out_of_stock_sizes field) when it doesn't.
export const deriveStockState = (stockQty, sizesIn) => {
  const sq = stockQty || {};
  if (sizeKeys(sq).length === 0) return null;
  const sizes = sizesIn || [];
  const oosSizes = sizes.filter((s) => (parseInt(sq[s], 10) || 0) <= 0);
  return { oosSizes };
};

export const isSkuOutOfStock = (stockQty, selectedSize) => {
  const sq = stockQty || {};
  if (sizeKeys(sq).length === 0) return false;
  return (parseInt(sq[selectedSize], 10) || 0) <= 0;
};
